// extracted by mini-css-extract-plugin
export default {"accountHeader":"ul-z","newDesignAccountHeader":"vl-z","primeBadge":"wl-z","logout":"xl-z"};